import { useAuth } from "oidc-react";
import { createContext } from "react";

export const BearerTokenContext = createContext<string | undefined>(undefined);

export function BearerTokenProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { userData } = useAuth();
  return (
    <BearerTokenContext.Provider value={userData?.access_token}>
      {children}
    </BearerTokenContext.Provider>
  );
}
